import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21c78b1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "推荐歌单", -1));
const _hoisted_2 = {
  class: "songName"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title2"
}, "最新音乐", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_SingleSong = _resolveComponent("SingleSong");
  const _component_lazy_component = _resolveComponent("lazy-component");
  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createVNode(_component_van_row, {
    gutter: "8"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, obj => {
      return _openBlock(), _createBlock(_component_van_col, {
        span: "8",
        key: obj.id
      }, {
        default: _withCtx(() => [_createVNode(_component_van_image, {
          width: "100%",
          height: "3rem",
          fit: "cover",
          src: obj.picUrl
        }, null, 8, ["src"]), _createElementVNode("p", _hoisted_2, _toDisplayString(obj.name), 1)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }), _hoisted_3, _createVNode(_component_lazy_component, null, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.songList, obj => {
      return _openBlock(), _createBlock(_component_SingleSong, {
        key: obj.id,
        name: obj.name,
        id: obj.id,
        author: obj.song.artists[0].name
      }, null, 8, ["name", "id", "author"]);
    }), 128))]),
    _: 1
  })]);
}